var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("tool-bar", { attrs: { title: "Nursing Service Logs" } }),
      _vm._v(" "),
      _c(
        "v-container",
        { class: { "pa-0 mt-0": _vm.isMobile, "margin-top": !_vm.isMobile } },
        [
          _c(
            "v-card",
            { class: { "full-height": _vm.isMobile } },
            [
              _vm.showLoading ? _c("loading-component") : _vm._e(),
              _vm._v(" "),
              _c(
                "v-card-text",
                { attrs: { "text-xs-left": "" } },
                [
                  _vm.appReady
                    ? _c(
                        "v-container",
                        [
                          _c(
                            "v-layout",
                            { attrs: { row: "", wrap: "" } },
                            [
                              _c(
                                "v-flex",
                                {
                                  class: {
                                    md5: _vm.submissionArray.length,
                                    "sm6 offset-sm3 md4 offset-md4": !_vm
                                      .submissionArray.length
                                  },
                                  attrs: { xs12: "" }
                                },
                                [_c("select-students")],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  class: {
                                    "md5 offset-md2":
                                      _vm.submissionArray.length,
                                    "sm6 offset-sm3 md4 offset-md4": !_vm
                                      .submissionArray.length
                                  },
                                  attrs: { xs12: "" }
                                },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticStyle: { height: "60px" },
                                      attrs: {
                                        color: "primary",
                                        dark: "",
                                        block: ""
                                      },
                                      on: { click: _vm.goToSearch }
                                    },
                                    [
                                      _c("v-icon", { staticClass: "pr-3" }, [
                                        _vm._v(
                                          "\n                  search\n                "
                                        )
                                      ]),
                                      _vm._v(
                                        "\n                Search Service Logs\n              "
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-flex", { attrs: { xs12: "" } }, [
                            _vm.submissionArray && _vm.submissionArray.length
                              ? _c(
                                  "div",
                                  { staticStyle: { "margin-top": "30px" } },
                                  [
                                    _c(
                                      "label",
                                      {
                                        class: {
                                          "subheading font-weight-medium":
                                            _vm.isMobile,
                                          "subheading font-weight-bold pb-1": !_vm.isMobile
                                        },
                                        staticStyle: {
                                          "text-align": "left",
                                          float: "left"
                                        },
                                        attrs: { for: "expansion" }
                                      },
                                      [
                                        _vm._v(
                                          "\n                Recent Service Logs\n              "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-expansion-panel",
                                      { attrs: { id: "expansion" } },
                                      _vm._l(_vm.submissionArray, function(
                                        submission,
                                        index
                                      ) {
                                        return _c(
                                          "v-expansion-panel-content",
                                          {
                                            key: index,
                                            staticStyle: {
                                              "background-color": "#d3d3d3"
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  "margin-left": "-18px"
                                                },
                                                attrs: { slot: "header" },
                                                slot: "header"
                                              },
                                              [
                                                _c("strong", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("formatDate")(
                                                        submission.date
                                                      )
                                                    )
                                                  )
                                                ]),
                                                _vm._v(
                                                  "\n                    (" +
                                                    _vm._s(
                                                      submission.logs.length
                                                    ) +
                                                    ")\n                  "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm._l(submission.logs, function(
                                              log,
                                              i
                                            ) {
                                              return _c(
                                                "div",
                                                { key: i },
                                                [
                                                  _c(
                                                    "v-container",
                                                    {
                                                      staticClass: "pa-2",
                                                      class: {
                                                        "light-gray-bg":
                                                          i % 2 !== 0,
                                                        "white-bg": i % 2 === 0
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-layout",
                                                        {
                                                          class: {
                                                            "xs-font":
                                                              _vm.isMobile,
                                                            "sm-up-font": !_vm.isMobile
                                                          },
                                                          attrs: {
                                                            row: "",
                                                            wrap: ""
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "v-flex",
                                                            {
                                                              class: {
                                                                "pb-3":
                                                                  _vm.isMobile
                                                              },
                                                              attrs: {
                                                                xs12: "",
                                                                sm6: "",
                                                                md5: ""
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.showConfirmation(
                                                                    log
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _c("div", [
                                                                _c("strong", [
                                                                  _vm._v(
                                                                    "\n                              " +
                                                                      _vm._s(
                                                                        log.studentFirstName
                                                                      ) +
                                                                      " " +
                                                                      _vm._s(
                                                                        log.studentLastName
                                                                      ) +
                                                                      "\n                              (" +
                                                                      _vm._s(
                                                                        log.studentExtId
                                                                      ) +
                                                                      ")\n                            "
                                                                  )
                                                                ])
                                                              ]),
                                                              _vm._v(" "),
                                                              _c("div", [
                                                                _vm._v(
                                                                  "\n                            " +
                                                                    _vm._s(
                                                                      log.studentSchoolName
                                                                    ) +
                                                                    " (" +
                                                                    _vm._s(
                                                                      log.grade
                                                                    ) +
                                                                    ")\n                          "
                                                                )
                                                              ]),
                                                              _vm._v(" "),
                                                              log.needLevel ===
                                                              "ABSENT"
                                                                ? _c("div", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        log.needLevel
                                                                      )
                                                                    )
                                                                  ])
                                                                : _c("div", [
                                                                    _vm._v(
                                                                      "\n                            " +
                                                                        _vm._s(
                                                                          _vm._f(
                                                                            "militaryTimeToStandard"
                                                                          )(
                                                                            log.sessionTime
                                                                          )
                                                                        ) +
                                                                        "\n                            "
                                                                    ),
                                                                    log.sessionMinutes
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              "\n                            (" +
                                                                                _vm._s(
                                                                                  log.sessionMinutes
                                                                                ) +
                                                                                " mins)\n                          "
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm._e()
                                                                  ]),
                                                              _vm._v(" "),
                                                              _c("div", [
                                                                _vm._v(
                                                                  "\n                            " +
                                                                    _vm._s(
                                                                      log.locationName
                                                                    ) +
                                                                    "\n                            "
                                                                ),
                                                                log.locationOther
                                                                  ? _c("span", [
                                                                      _vm._v(
                                                                        ": " +
                                                                          _vm._s(
                                                                            log.locationOther
                                                                          )
                                                                      )
                                                                    ])
                                                                  : _vm._e()
                                                              ]),
                                                              _vm._v(" "),
                                                              _c("div", [
                                                                _vm._v(
                                                                  "\n                            " +
                                                                    _vm._s(
                                                                      log.deliveryMode
                                                                    ) +
                                                                    "\n                          "
                                                                )
                                                              ]),
                                                              _vm._v(" "),
                                                              _c("div", [
                                                                log.roomName
                                                                  ? _c("span", [
                                                                      _vm._v(
                                                                        ": " +
                                                                          _vm._s(
                                                                            log.roomName
                                                                          )
                                                                      )
                                                                    ])
                                                                  : _vm._e()
                                                              ]),
                                                              _vm._v(" "),
                                                              _c(
                                                                "v-layout",
                                                                {
                                                                  attrs: {
                                                                    row: "",
                                                                    wrap: ""
                                                                  }
                                                                },
                                                                [
                                                                  log.hasAttachments
                                                                    ? _c(
                                                                        "v-icon",
                                                                        [
                                                                          _vm._v(
                                                                            "attach_file"
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e()
                                                                ],
                                                                1
                                                              )
                                                            ],
                                                            1
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "v-flex",
                                                            {
                                                              attrs: {
                                                                xs12: "",
                                                                sm6: "",
                                                                md5: ""
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.showConfirmation(
                                                                    log
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _c("div", [
                                                                _vm._v(
                                                                  "\n                            " +
                                                                    _vm._s(
                                                                      log.serviceName
                                                                    ) +
                                                                    "\n                          "
                                                                )
                                                              ]),
                                                              _vm._v(" "),
                                                              _c("div", [
                                                                _vm._v(
                                                                  "\n                            " +
                                                                    _vm._s(
                                                                      _vm._f(
                                                                        "formatDate"
                                                                      )(
                                                                        log.serviceStartDate
                                                                      )
                                                                    ) +
                                                                    " -\n                            " +
                                                                    _vm._s(
                                                                      _vm._f(
                                                                        "formatDate"
                                                                      )(
                                                                        log.serviceEndDate
                                                                      )
                                                                    ) +
                                                                    "\n                          "
                                                                )
                                                              ]),
                                                              _vm._v(" "),
                                                              _c("div", [
                                                                _vm._v(
                                                                  "\n                            " +
                                                                    _vm._s(
                                                                      log.providerFirstName +
                                                                        " " +
                                                                        log.providerLastName
                                                                    ) +
                                                                    "\n                            "
                                                                ),
                                                                log.providerCredential
                                                                  ? _c("span", [
                                                                      _vm._v(
                                                                        "\n                            /\n                            " +
                                                                          _vm._s(
                                                                            log.providerCredential
                                                                          ) +
                                                                          "\n                          "
                                                                      )
                                                                    ])
                                                                  : _vm._e()
                                                              ])
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "v-flex",
                                                            {
                                                              attrs: {
                                                                xs12: "",
                                                                md2: ""
                                                              }
                                                            },
                                                            [
                                                              _vm.isMobile ||
                                                              _vm.isTablet
                                                                ? _c(
                                                                    "v-divider",
                                                                    {
                                                                      staticClass:
                                                                        "my-2"
                                                                    }
                                                                  )
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              _c(
                                                                "action-icons",
                                                                {
                                                                  attrs: {
                                                                    fromDashboard: true,
                                                                    submission: log
                                                                  },
                                                                  on: {
                                                                    "service-log:deleted":
                                                                      _vm.loadDashboard
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            })
                                          ],
                                          2
                                        )
                                      }),
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ])
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.confirmationDialog
        ? _c(
            "div",
            [
              _c("submission-history", {
                attrs: {
                  submission: _vm.confirmationDialog,
                  fromDashboard: true
                },
                on: {
                  "reload:page": _vm.loadDashboard,
                  "dialog:closed": _vm.historyDialogClosed
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("bottom-nav")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6492da79", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6492da79","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/dashboard.vue
// module id = null
// module chunks = 